/**
 * The Value for the offset that the Tooltip is displayed
 */
export const TOOLTIP_OFFSET = 10;
export const TOOLTIP_X_OFFSET = 60;
